// sepomex_lookup.js
// Busca código postal vía SEPOMEX y, si aplica, muestra selector de Localidad CNBV.

(function() {
  var DEFAULT_OPTION = '<option value="">Selecciona una opción</option>';

  var MESSAGES = {
    postalEmpty:   'Favor de registrar el nuevo código postal.',
    postalFailed:  'No se pudo validar el código postal.',
    cnbvEmpty:     'Favor de registrar la ubicación de CNBV.'
  };

  function upcase(value) {
    return (value || '').toString().toUpperCase();
  }

  function showAlert(node, message) {
    if (!node) return;
    node.textContent = message;
    node.classList.remove('d-none');
  }

  function hideAlert(node) {
    if (!node) return;
    node.textContent = '';
    node.classList.add('d-none');
  }

  function initSepomexLookup() {
    var postalInput = document.querySelector('[data-postal-code-lookup="true"]');
    if (!postalInput || postalInput.dataset.sepomexInitialized === 'true') return;
    postalInput.dataset.sepomexInitialized = 'true';

    var form = postalInput.closest('form');
    if (!form) return;

    var stateInput            = form.querySelector('#merchant_state');
    var stateCodeInput        = form.querySelector('#merchant_state_code');
    var colonyInput           = form.querySelector('#merchant_colony');
    var municipalityInput     = form.querySelector('#merchant_municipality');
    var sepomexZipCodeIdInput = form.querySelector('#merchant_sepomex_zip_code_id');

    var optionWrapper = form.querySelector('#sepomex-option-wrapper');
    var optionSelect  = form.querySelector('#sepomex-option-select');

    var cnbvZipCodeIdInput = form.querySelector('#merchant_cnbv_location_catalog_id');
    var cnbvWrapper        = form.querySelector('#cnbv-option-wrapper');
    var cnbvSelect         = form.querySelector('#cnbv-option-select');

    var sepomexError = form.querySelector('#sepomex-lookup-error');
    var cnbvError    = form.querySelector('#cnbv-lookup-error');
    var lookupButton = form.querySelector('#sepomex-lookup-button');

    var currentOptions = [];

    function clearAssignedFields() {
      if (stateInput)            stateInput.value = '';
      if (stateCodeInput)        stateCodeInput.value = '';
      if (colonyInput)           colonyInput.value = '';
      if (municipalityInput)     municipalityInput.value = '';
      if (sepomexZipCodeIdInput) sepomexZipCodeIdInput.value = '';
      if (cnbvZipCodeIdInput)    cnbvZipCodeIdInput.value = '';
    }

    function hideAllSelectors() {
      if (optionWrapper) optionWrapper.style.display = 'none';
      if (cnbvWrapper)   cnbvWrapper.style.display   = 'none';
      if (optionSelect)  optionSelect.innerHTML = DEFAULT_OPTION;
      if (cnbvSelect)    cnbvSelect.innerHTML   = DEFAULT_OPTION;
    }

    function clearAlerts() {
      hideAlert(sepomexError);
      hideAlert(cnbvError);
    }

    function assignFields(option) {
      postalInput.value           = upcase(option.d_codigo);
      stateInput.value            = upcase(option.d_estado);
      stateCodeInput.value        = upcase(option.c_estado);
      colonyInput.value           = upcase(option.d_asenta);
      municipalityInput.value     = upcase(option.d_mnpio);
      sepomexZipCodeIdInput.value = option.id;
    }

    function renderSelector(options) {
      if (!optionSelect || !optionWrapper) return;

      optionSelect.innerHTML = DEFAULT_OPTION;

      options.forEach(function(option, index) {
        var node = document.createElement('option');
        node.value = index;
        node.textContent =
          upcase(option.d_asenta) + ' - ' +
          upcase(option.d_mnpio) + ', ' +
          upcase(option.d_estado);
        optionSelect.appendChild(node);
      });

      optionWrapper.style.display = 'block';
    }

    function renderCnbvSelector(candidates) {
      if (!cnbvSelect || !cnbvWrapper) return;

      cnbvSelect.innerHTML = DEFAULT_OPTION;

      candidates.forEach(function(c) {
        var node = document.createElement('option');
        node.value = c.id;
        node.textContent = c.name;
        cnbvSelect.appendChild(node);
      });

      cnbvWrapper.style.display = 'block';
    }

    function lookupPostalCode() {
      var postalCode = (postalInput.value || '').trim();

      clearAlerts();
      hideAllSelectors();
      clearAssignedFields();

      if (postalCode.length !== 5) return;

      fetch(postalInput.dataset.lookupUrl + '?postal_code=' + encodeURIComponent(postalCode), {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        // Caso 1: SEPOMEX no devolvió opciones
        if (!data.found || !data.options || data.options.length === 0) {
          showAlert(sepomexError, MESSAGES.postalEmpty);
          return;
        }

        currentOptions = data.options;

        if (currentOptions.length === 1) {
          assignFields(currentOptions[0]);
        } else {
          renderSelector(currentOptions);
        }

        // Caso 2: CNBV no devolvió opciones
        if (data.cnbv_candidates && data.cnbv_candidates.length > 0) {
          renderCnbvSelector(data.cnbv_candidates);
        } else {
          showAlert(cnbvError, MESSAGES.cnbvEmpty);
        }
      })
      .catch(function() {
        showAlert(sepomexError, MESSAGES.postalFailed);
      });
    }

    postalInput.addEventListener('blur', lookupPostalCode);
    if (lookupButton) lookupButton.addEventListener('click', lookupPostalCode);

    if (optionSelect) {
      optionSelect.addEventListener('change', function(event) {
        var index = parseInt(event.target.value, 10);
        if (Number.isNaN(index) || !currentOptions[index]) {
          clearAssignedFields();
          return;
        }
        assignFields(currentOptions[index]);
      });
    }

    if (cnbvSelect) {
      cnbvSelect.addEventListener('change', function(event) {
        if (cnbvZipCodeIdInput) cnbvZipCodeIdInput.value = event.target.value;
      });
    }
  }

  if (typeof Turbo !== 'undefined') {
    document.addEventListener('turbo:load', initSepomexLookup);
  } else if (typeof Turbolinks !== 'undefined') {
    document.addEventListener('turbolinks:load', initSepomexLookup);
  } else {
    document.addEventListener('DOMContentLoaded', initSepomexLookup);
  }
})();